import React, { useState } from "react";
import { getData } from "../helper/helper";
import Vt from "../img/vt.svg";
import Close from "../img/close.svg";

const VirtualTour = ({locale}) => {
  const footer = getData(locale).footer;
  const [active, setActive] = useState(false);

  return (
    <div className="virtual">
      <button onClick={() => setActive(true)}>
        <Vt />
        {footer.virtual}
      </button>

      {active && (
        <div className="overlay" onClick={() => setActive(false)} aria-hidden="true">
          <div className="tourModal">
            <Close onClick={() => setActive(false)} />
            <iframe
              width="100%"
              height="520"
              src="https://my.matterport.com/show/?m=xJJKRayCv6H"
              frameBorder="0"
              allowFullScreen
              allow="xr-spatialtracking"
              title='360 Tour'
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default VirtualTour;
